import type { SvgIconProps } from '@mui/material/SvgIcon';
import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

const StreamerBoxIconBase = createSvgIcon(
  <g transform="scale(0.85) translate(42.5, 42.5)">
    <path
      d="M532.739,336.057H85.945V63.702c9.478-6.189,15.777-16.848,15.777-29.015C101.723,15.529,86.166,0,67.026,0
    C47.888,0,32.331,15.53,32.331,34.688c0,12.167,6.302,22.825,15.777,29.015v272.354H34.805C15.591,336.057,0,351.64,0,370.861
    v143.216c0,19.221,15.591,34.807,34.804,34.807h43.231v5.663c0,7.177,5.82,12.997,13.007,12.997h63.848
    c7.185,0,13.007-5.82,13.007-12.997v-5.663h231.747v5.663c0,7.177,5.82,12.997,13.007,12.997h63.85
    c7.188,0,13.006-5.82,13.006-12.997v-5.663h43.232c19.213,0,34.805-15.586,34.805-34.807V370.861
    C567.545,351.638,551.952,336.057,532.739,336.057z M212.869,499.224H81.992c-10.457,0-18.917-8.47-18.917-18.917
    s8.459-18.917,18.917-18.917h130.875c10.455,0,18.917,8.472,18.917,18.917C231.786,490.754,223.324,499.224,212.869,499.224z
     M212.869,423.552H81.992c-10.457,0-18.917-8.472-18.917-18.919c0-10.448,8.459-18.917,18.917-18.917h130.875
    c10.455,0,18.917,8.471,18.917,18.917C231.786,415.08,223.324,423.552,212.869,423.552z M520.268,480.093
    c0,11.871-9.627,21.495-21.487,21.495H313.184c-11.879,0-21.504-9.624-21.504-21.495v-75.247c0-11.869,9.625-21.496,21.504-21.496
    h185.597c11.862,0,21.487,9.625,21.487,21.496V480.093L520.268,480.093z"
    />
  </g>,
  'StreamerBox',
);

const StreamerBoxIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return <StreamerBoxIconBase {...props} ref={ref} viewBox="0 0 567 567" />;
});

StreamerBoxIcon.displayName = 'StreamerBoxIcon';

export { StreamerBoxIcon };

export default StreamerBoxIcon;
